// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"60px","side-bar-container":"styles_side-bar-container__1uUFs","sideBarContainer":"styles_side-bar-container__1uUFs"};